/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsButtonRowViewProps } from './../../../modules/hosports-button-row/./hosports-button-row';
import Button from './../../../baseComponents/button/./button';

class HosportsButtonRow extends React.Component<IHosportsButtonRowViewProps> {

  public render(): JSX.Element {
    const { config } = this.props;
    let buttonBackgroundColor:any = '#000';
    let buttonTextColor:any = '#fff';
    let link:any = config.link;
    if(config.theme && config.theme == "dark"){
      buttonBackgroundColor = '#fff';
      buttonTextColor = '#000';
    }
    return (
      <div className="tiny-padding centered-text">
        {link && link.linkUrl && link.linkUrl.destinationUrl &&
          <div className="card-button">
            <a href={link.linkUrl ? link.linkUrl.destinationUrl : ''}>
              {
                <Button className={'primary-background white'} text={link.linkText} backgroundColor={buttonBackgroundColor} color={buttonTextColor} />
              }
            </a>
          </div>
        }
      </div>
    );
  }
}

export default HosportsButtonRow;
